<template>
  <div class="secret-container">
    <el-drawer
      :visible.sync="showDrawer"
      :show-close="false"
      :with-header="false"
      direction="ltr"
    >
      <div class="catalogue-list" :style="style">
        <div class="top-title">
          <span>共{{ total.chaptersNum }}章</span>
          <span>{{ total.knowledgeNum }}个知识点</span>
        </div>
        <div class="catalogue-content">
          <div
            class="firststage"
            v-for="(item, index) in parentSecretData"
            :key="index"
          >
            <div class="title list-item">{{ item.title }}</div>
            <div class="children">
              <div
                class="sencondstage list-item"
                v-for="sub in item.children"
                :key="sub.id"
                @click="hanldeStageClick(sub.id)"
                :class="{ active: currentStageNum === sub.id }"
              >
                {{ sub.title }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-drawer>
    <div class="content">
      <div class="catalogue" @click="hanldeClickCatalogue">目录</div>
      <div class="pre-page" @click="hanldePreClick">上一页</div>
      <div class="next-page" @click="hanldeNextClick">下一页</div>
      <div class="content-container">
        <div class="stage-title">{{ currentContent.title }}</div>
        <div class="stage-content" v-html="currentContent.content"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mall } from '../../request';
export default {
  name: 'BeforeTransSecret',
  data() {
    return {
      showDrawer: false, // 目录展示
      currentStageNum: 1, // 当前stage
      style: {
        paddingTop: '30px',
        paddingLeft: '15px',
      },
      total: {
        chaptersNum: 4,
        knowledgeNum: 109,
      },
      parentSecretData: [],
      reviewid: '',
      cstid: '',
      knowledgeSecretData: [],
      currentContent: {},
    };
  },
  mounted() {
    const { reviewid, cstid } = this.$route.params;
    this.reviewid = reviewid;
    this.cstid = cstid;
    this.getStageList(reviewid, cstid);
  },
  methods: {
    // 获取目录
    getStageList(reviewid, cstid) {
      mall.getSecretCatalogue(reviewid, cstid).then(res => {
        const {
          chaptersNum,
          knowledgeNum,
          parentSecretData,
          knowledgeSecretData,
        } = res.data;
        this.total.chaptersNum = chaptersNum;
        this.total.knowledgeNum = knowledgeNum;
        this.parentSecretData = parentSecretData;
        this.currentStageNum = knowledgeSecretData[0].id;
        this.currentContent = knowledgeSecretData[0];
        this.knowledgeSecretData = knowledgeSecretData;
      });
    },
    hanldeClickCatalogue() {
      this.showDrawer = true;
    },
    hanldeStageClick(key) {
      this.currentStageNum = key;
      const { knowledgeSecretData } = this;
      knowledgeSecretData.map(item => {
        if (key === item.id) {
          this.currentContent = item;
          this.showDrawer = false;
        }
      });
    },
    hanldePreClick() {
      let { currentStageNum, knowledgeSecretData } = this;
      const currentIndex = knowledgeSecretData.findIndex(
        m => m.id === currentStageNum
      );
      if (currentIndex <= 0) {
        this.$message({
          message: '已经是最前的一节',
          type: 'error',
        });
      } else {
        this.currentStageNum = knowledgeSecretData[currentIndex - 1].id;
        this.currentContent = knowledgeSecretData[currentIndex - 1];
        this.showDrawer = false;
        // this.currentStageNum = currentStageNum - 1;
        // knowledgeSecretData.map(item => {
        //   if (this.currentStageNum === item.id) {
        //     this.currentContent = item;
        //     this.showDrawer = false;
        //   }
        // });
      }
    },
    hanldeNextClick() {
      let { currentStageNum, knowledgeSecretData } = this;
      const currentIndex = knowledgeSecretData.findIndex(
        m => m.id === currentStageNum
      );
      const currentLength = knowledgeSecretData.length;
      if (currentIndex + 1 >= currentLength) {
        this.$message({
          message: '已经是最后的一节',
          type: 'error',
        });
      } else {
        this.currentStageNum = knowledgeSecretData[currentIndex + 1].id;
        this.currentContent = knowledgeSecretData[currentIndex + 1];
        this.showDrawer = false;
        // this.currentStageNum = currentStageNum + 1;
        // knowledgeSecretData.map(item => {
        //   if (this.currentStageNum === item.id) {
        //     this.currentContent = item;
        //     this.showDrawer = false;
        //   }
        // });
      }
    },
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}

.secret-container {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background-color: #555555;
}

.content {
  width: 50%;
  height: 100vh;
  position: relative;
  background-color: #ffffff;
  padding: 20px 20px 0;
  box-sizing: border-box;
}
.content-container {
  display: flex;
  align-items: center;
  flex-direction: column;
  height: 100vh;
}

.content-container .stage-title {
  width: 400px;
  margin-bottom: 20px;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
}

.content-container .stage-content {
  width: 100%;
  height: 850px;
  user-select: none;
  overflow-y: auto;
}
.stage-content img {
  display: inline-block;
  vertical-align: middle;
}

.catalogue,
.pre-page,
.next-page {
  width: 70px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  background-color: #02a7f0;
  position: absolute;
  cursor: pointer;
}

.catalogue,
.pre-page {
  border-radius: 30px 0 0 30px;
}

.next-page {
  border-radius: 0 30px 30px 0;
}

.catalogue {
  left: -70px;
  top: 30px;
}

.next-page,
.pre-page {
  top: 50%;
}

.next-page {
  right: -70px;
}

.pre-page {
  left: -70px;
}

.catalogue-list .top-title {
  margin-left: 20px;
  margin-bottom: 40px;
  color: #666666;
}

.catalogue-list .catalogue-content {
  height: calc(100vh - 21px - 40px - 30px);
  overflow-y: auto;
}

.catalogue-content .list-item {
  /* width: 373px; */
  box-sizing: border-box;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  padding-top: 15px;
  padding-bottom: 30px;
  font-size: 16px;
  border-bottom: 1px solid #d7d7d7;
}

.sencondstage {
  cursor: pointer;
  padding-left: 30px;
}

.firststage .children .active {
  color: #0590ff;
}
</style>
